import { useDateNow, useReduxState } from 'hooks';
import { getFormattedDate } from 'lib/common';
import { FormGroup, Text } from 'components/common/form';

interface Props {
  field: string;
  label?: string;
  value: Parameters<typeof getFormattedDate>[0]['dateFormat'];
  required?: boolean;
}

const DateFormat = ({ field, label, value, required }: Props) => {
  const { dateNow } = useDateNow();

  const { theme } = useReduxState();

  const validateDateFormat = (value: string) => {
    try {
      if (!required && !value?.length) {
        return;
      } else {
        getFormattedDate({ date: Date.now(), dateFormat: value });
      }
    } catch {
      return 'Invalid Date Format';
    }
  };

  return (
    <FormGroup label={label || 'Date formatting'}>
      <Text
        field={field}
        placeholder={"yyyy-MM-dd'T'HH:mm:ss.sss'Z'"}
        style={{ width: 300, display: 'inline-block' }}
        validate={validateDateFormat}
        validateOnChange={true}
        keepState
      />
      {!validateDateFormat(value) && value?.length > 0 && (
        <div className="date-format-preview">
          {`Example: ${getFormattedDate({
            date: dateNow,
            dateFormat: value
          })}`}
        </div>
      )}
      <style jsx>{`
        .date-format-preview {
          color: ${theme.textColor};
          font-size: 1.5rem;
          padding: 3px;
          background: ${theme.lightGreyLighter};
          border: 1px solid ${theme.lightGreyDark};
          border-radius: 3px;
          max-width: 300px;
          margin-top: 3px;
        }
      `}</style>
    </FormGroup>
  );
};

export default DateFormat;
